import React from "react"
import Modal from "react-bootstrap/Modal"
import * as styles from "./Styles/PC.module.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)
import Loader from "../../Loader"

const LocationModal = (props) => {
  const regions = props.prefecture ? [] : props.locations
  const cities = props.prefecture ? props.prefecture.cities : []
  const onLocationClick = (e, city, pref) => {
    e.preventDefault()
    // call Filter.tsx#handleLocation
    props.onChange(city, pref)
  }
  return (
    <Modal show={props.show} onHide={props.onHide}>
      <Modal.Header>
        <div className={styles.modalHeader}>エリアをえらぶ</div>
      </Modal.Header>
      <Modal.Body>
        {regions.length == 0 && cities.length == 0 && (
          <div style={{ paddingBottom: "1rem" }}>
            <Loader show={regions.length == 0} color="green" small={false} />
          </div>
        )}
        {regions.length > 0 && (
          <React.Fragment>
            <div className={styles.children}>
              <div className={styles.child}>
                <a
                  href="#"
                  onClick={(e) => {
                    onLocationClick(e, null, null)
                  }}
                >
                  現在地周辺
                </a>
              </div>
            </div>
            {regions.map((r, i) => (
              <React.Fragment key={i}>
                <div className={styles.header}>
                  <h3>{r.name}</h3>
                </div>
                <div className={styles.children}>
                  {r.prefectures.map((pref, j) => (
                    <React.Fragment key={j}>
                      <div className={styles.child}>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault()
                            props.setPrefecture(pref)
                          }}
                        >
                          {pref.name}
                        </a>
                      </div>
                    </React.Fragment>
                  ))}
                </div>
              </React.Fragment>
            ))}
          </React.Fragment>
        )}
        {cities.length > 0 && (
          <React.Fragment>
            <div className={styles.navigation}>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  props.setPrefecture(null)
                }}
                className={styles.deselected}
              >
                全国
              </a>
              <a
                href="#"
                onClick={(e) => {
                  onLocationClick(e, null, props.prefecture)
                }}
                className={styles.selected}
              >
                {props.prefecture.name}全域
              </a>
            </div>
            <div className={cn("children", "cities")}>
              {cities.map((city, i) => (
                <React.Fragment key={i}>
                  <div className={styles.child}>
                    <a
                      href="#"
                      onClick={(e) => {
                        onLocationClick(e, city, props.prefecture)
                      }}
                    >
                      {city.name}
                      {Object.keys(props.placeCountByCities || {}).length >
                        0 && (
                        <span>
                          ({props.placeCountByCities[city.id] || "0"})
                        </span>
                      )}
                    </a>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </React.Fragment>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default LocationModal
